module.exports = __webpack_public_path__ + "media/assets/images/tenant-portal-tips/heating2-dcd14a6b0104446a3628cd19ffa01d36.jpg";